// @flow
import update from 'immutability-helper'

import type { GlobalContextState, GlobalContextAction } from './types.flow'

const modalUpdate = (state, payload): GlobalContextState => {
  return update(state, {
    modal: { $merge: payload }
  })
}

const modalOpen = (state, payload): GlobalContextState => {
  return update(state, {
    modal: { $set: payload }
  })
}

const modalClose = (state): GlobalContextState => {
  return update(state, {
    modal: {
      $set: {
        title: '',
        content: null,
        isCloseDisabled: false
      }
    }
  })
}

const updatePbxState = (state, payload): GlobalContextState => {
  return update(state, {
    pbx: { $merge: payload }
  })
}

const setAuthInfo = (state, payload): GlobalContextState => {
  return update(state, {
    auth: { $set: payload }
  })
}

const setPermissions = (state, payload): GlobalContextState => {
  return update(state, {
    permissions: { $set: payload }
  })
}

const setContentScroll = (state, payload): GlobalContextState => {
  const pageWrapper = document.getElementById('page-wrapper')

  if (pageWrapper) {
    pageWrapper.scroll(payload)
  }

  return state
}

const reducer = (state: GlobalContextState, action: GlobalContextAction) => {
  switch (action.type) {
    case 'modal/open':
      return modalOpen(state, action.payload)
    case 'modal/update':
      return modalUpdate(state, action.payload)
    case 'modal/close':
      return modalClose(state)
    case 'pbx/update':
      return updatePbxState(state, action.payload)
    case 'auth/update':
      return setAuthInfo(state, action.payload)
    case 'permissions/set':
      return setPermissions(state, action.payload)
    case 'content/scroll':
      return setContentScroll(state, action.payload)
    default:
      console.error('[GlobalContext] Unhandled action type ', action.type)
      return state
  }
}

export default reducer
